import styled from '@emotion/styled'
import { IonCard, IonCardContent } from '@ionic/react'
import { especializacao, atualizacao, reciclagem } from './MatriculasConstants'
import { MatriculaStore } from './MatriculasStore'
import { Cupom } from './Cupom'

export const MatriculaCurso = () => {
  return (
    <MatriculaStore.Provider>
      <Layout />
    </MatriculaStore.Provider>
  )
}

function Layout() {
  const { Container } = Layout
  return (
    <div style={{ overflowY: 'scroll' }}>
      <Container>
        <Cabeçalho />
        <Cupom />
        <Cursos />
      </Container>
    </div>
  )
}
Layout.Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 10px;
  margin-top: 20px;
`

function Cabeçalho() {
  return <strong>Bem vindo à New Driver</strong>
}

const ContainerTipoCurso = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
`
const ContainerCursos = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 20px;
`

function Cursos() {
  return (
    <div>
      <CursoReciclagem />
      <CursoCapacitacao />
      <CursoAtualizacao />
    </div>
  )
}

function CursoReciclagem() {
  return (
    <ContainerTipoCurso>
      <div>
        <strong>Curso de Reciclagem:</strong> Recupere sua carteira em tempo recorde
      </div>
      <ContainerCursos>
        {reciclagem.map((curso) => (
          <Curso key={curso.id} curso={{ ...curso, categoria: 'reciclagem' }} />
        ))}
      </ContainerCursos>
    </ContainerTipoCurso>
  )
}

function CursoCapacitacao() {
  return (
    <ContainerTipoCurso>
      <div>
        <strong>Curso de Especialização:</strong> Aprimore suas habilidades e se destaque em sua
        profissão com nossos cursos de capacitação.
      </div>
      <ContainerCursos>
        {especializacao.map((curso) => (
          <Curso key={curso.id} curso={{ ...curso, categoria: 'especializacao' }} />
        ))}
      </ContainerCursos>
    </ContainerTipoCurso>
  )
}

function CursoAtualizacao() {
  return (
    <ContainerTipoCurso>
      <div>
        <strong>Curso de Atualização:</strong> Este curso é projetado para ajudá-lo a atualizar suas
        habilidades e conhecimentos existentes.
      </div>
      <ContainerCursos>
        {atualizacao.map((curso) => (
          <Curso key={curso.id} curso={{ ...curso, categoria: 'atualizacao' }} />
        ))}
      </ContainerCursos>
    </ContainerTipoCurso>
  )
}

type tCurso = {
  id: number
  nome: string
  urlSlug: string
  urlSlugCapacitacao?: string
  urlSlugAtualizacao?: string
  categoria?: 'reciclagem' | 'especializacao' | 'atualizacao'
}

function Curso({ curso }: { curso: tCurso }) {
  const { Img, Card, NomeCurso, Content } = Curso
  const urlImg = process.env.PUBLIC_URL + '/assets/cursos/' + curso.id + '.webp'
  const searchParams = new URLSearchParams(location.search)

  const handleClick = () => {
    const slug = curso.urlSlug
    const params = new URLSearchParams()
    params.set('cupom', searchParams.get('cupom') ?? '')
    params.set('categoria', curso.categoria ?? '')
    const search = params?.toString() ? '?' + params?.toString() : ''
    window.open(`/matricula/${slug}${search}`, '_blank')
  }

  return (
    <Card onClick={handleClick}>
      <Img src={urlImg} />
      <Content>
        <NomeCurso>{curso.nome}</NomeCurso>
      </Content>
    </Card>
  )
}
Curso.NomeCurso = styled.div`
  font-weight: bold;
  color: #FF6422;
`
Curso.Img = styled.img`
  width: 300px;
  height: 180px;
  object-fit: cover;
  border-radius: 0px;
  padding: 0px;
  margin: 0px;
`
Curso.Content = styled(IonCardContent)`
  margin-left: 20px;
  margin-right: 20px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`
Curso.Card = styled(IonCard)`
  border-style: solid;
  border-width: 1px;
  border-color: #FF6422;
  border-radius: 0px;
  max-height: 300px;
  height: 100%;
  max-width: 300px;
  width: 100%;
  background: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0px;
  margin: 0px;
  transition: 0.3s;
  &:hover {
    transform: scale(1.05);
  }
`
